import * as React from "react";
import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import cargandoCard from "../../components/cargando-card";
// import sinAccesoCard from "../../components/sin-acceso-card";
import { useListaRequerimientosAsignacion } from "./const/columnas";
// import ArrowBack from "../../components/arrow-back";
import { useTranslation } from "react-i18next";
import { ChevronDown, ChevronUp, Upload } from "lucide-react";
import readXlsxFile from "read-excel-file";
import Select from "react-select";
import ToastComponent from "../../components/toast-component";
import ProcessingDialog from "../../components/processing-dialog";
import Spinner from "../../components/spinner";
import { ESTILO_BOTON_GENERAL_ACEPTAR, ESTILO_BOTON_GENERAL_CANCELAR } from "../../utils/const/estilos-const";
import { actualizarConfiguracionAsignacion, crearConfiguracionAsignacion, obtenerListaConfiguracionAsignacion } from "../../api/api-configuracion-asignacion";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB } from "../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../usuarios/gestionar-rol-usuario-web/pages-const";


export default function AsignacionConfiguracionPage() {
    const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
    const { t } = useTranslation();
    const history = useHistory();
    const [cargandoPage, setCargandoPage] = useState(true);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
    const [expandedItems, setExpandedItems] = useState({});
    // const [listaColumnasExcel, setListaColumnasExcel] = useState([]);
    const [excelValido, setExcelValido] = useState(false);
    const [selectedMappings, setSelectedMappings] = useState({}); // Maps requirement.value -> selected column
    const [availableOptions, setAvailableOptions] = useState([]); // Available columns for selection

    const LISTA_REQUERIMIENTOS_ASIGNACION = useListaRequerimientosAsignacion();

    const [processingVisible, setProcessingVisible] = useState(false);
    const [toastVisible, setToastVisible] = useState(false);
    const [toastMessage, setToastMessage] = useState("");
    const [toastType, setToastType] = useState("warning"); // "warning" | "success" | "error"
    const [requestSend, setRequestSend] = useState(false);

    const [configuracionAsignacion, setConfiguracionAsignacion] = useState(null);

    const [btnImportar, setBtnImportar] = useState(false);
    const [btnAceptar, setBtnAceptar] = useState(false);
    const [btnCancelar, setBtnCancelar] = useState(false);

    const toggleExpand = (itemValue) => {
        setExpandedItems(prev => ({
            ...prev,
            [itemValue]: !prev[itemValue]
        }));
    };

    useEffect(() => {
        // console.log('DashboardPage useEffect');
        iniciar();
    }, []);

    useEffect(() => {
        if (Object.keys(selectedMappings).length > 0) {
            // console.log('Selected Mappings (Requirement -> Column):');
            // console.log(selectedMappings);
        }
    }, [selectedMappings]);

    const iniciar = async () => {
        let tieneAcceso = false;
        try {
            let objEnviar = {};
            if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
                tieneAcceso = true;
                setBtnImportar(true);
                setBtnAceptar(true);
                setBtnCancelar(true);
            }
            if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
                const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
                objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
                const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
                if (response.error === false && response.data !== undefined) {
                    const permisos = JSON.parse(response.data.permisos);
                    // console.log('permisos');
                    // console.log(permisos);
                    if (Array.isArray(permisos) && permisos.length > 0) {
                        const manage = permisos.find(p => p.id === 5);
                        if (manage !== undefined && manage !== null) {
                            const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.ASIGNACION_CONFIGURACION);
                            // console.log('permisosPage');
                            // console.log(permisosPage);
                            tieneAcceso = permisosPage.checked;
                            if (tieneAcceso === false) {
                                return;
                            }
                            // console.log('permisosPage');
                            // console.log(permisosPage);
                            const permisoBtnImportar = permisosPage.acciones.find(a => a.value === 'btn_importar');
                            const permisoBtnAceptar = permisosPage.acciones.find(a => a.value === 'btn_aceptar');
                            const permisoBtnCancelar = permisosPage.acciones.find(a => a.value === 'btn_cancelar');
                            setBtnImportar(permisoBtnImportar?.checked);
                            setBtnAceptar(permisoBtnAceptar?.checked);
                            setBtnCancelar(permisoBtnCancelar?.checked);
                        }
                    }
                }
            }
            if (tieneAcceso === true) {
                const obtenerConfiguracionAsignacion = await obtenerListaConfiguracionAsignacion({}, false, t);
                // console.log('obtenerConfiguracion Asignacion');
                // console.log(obtenerConfiguracionAsignacion);
                if (Array.isArray(obtenerConfiguracionAsignacion) && obtenerConfiguracionAsignacion.length > 0) {
                    setConfiguracionAsignacion(obtenerConfiguracionAsignacion[0]);
                    setSelectedMappings(JSON.parse(obtenerConfiguracionAsignacion[0].configuracion));
                    setExcelValido(true);
                }
            }
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        } finally {
            setCargandoPage(false);
            setTieneAccesoAlModulo(tieneAcceso);
        }
    };

    const handleCancelClick = () => {
        history.goBack();
    };

    const onClickImportar = () => {
        const input = document.getElementById('importar_asignacion');
        input.click();
        setExcelValido(false);
        setSelectedMappings({});
        setAvailableOptions([]);
    };

    const handleSelectChange = (requirementValue, selectedOption) => {
        const previousSelection = selectedMappings[requirementValue];

        // Update selected mappings
        setSelectedMappings(prev => {
            const newMappings = { ...prev };
            if (selectedOption) {
                newMappings[requirementValue] = selectedOption;
            } else {
                delete newMappings[requirementValue];
            }
            return newMappings;
        });

        // Update available options
        setAvailableOptions(prev => {
            let newOptions = [...prev];

            // If there was a previous selection, add it back
            if (previousSelection) {
                newOptions.push(previousSelection);
                // Sort by value to maintain order
                newOptions.sort((a, b) => a.value - b.value);
            }

            // If a new option is selected, remove it
            if (selectedOption) {
                newOptions = newOptions.filter(opt => opt.value !== selectedOption.value);
            }

            return newOptions;
        });
    };

    const handleFileChange = async (event) => {
        try {
            const file = event.target.files[0];
            if (!file) {
                return;
            }

            // Check if file is xlsx
            if (!file.name.endsWith('.xlsx') && !file.name.endsWith('.xls')) {
                console.error('El archivo debe ser un archivo Excel (.xlsx o .xls)');
                setExcelValido(false);
                return;
            }

            // Read the Excel file
            const rows = await readXlsxFile(file);

            // console.log('Excel file content:');
            // console.log(rows);

            const headers = Array.isArray(rows[0]) ? rows[0] : [];
            // console.log('Headers:');
            // console.log(headers);
            // const valorEjemplo = Array.isArray(rows[1]) ? rows[1] : [];

            const listaColumnasExcel = headers.map((header, index) => {
                return {
                    value: index,
                    label: index + "-" + header,
                    // valorEjemplo: valorEjemplo[index],
                };
            });
            // console.log('Lista columnas Excel:');
            // console.log(listaColumnasExcel);
            // setListaColumnasExcel(listaColumnasExcel);
            setAvailableOptions(listaColumnasExcel); // Initialize available options
            setSelectedMappings({}); // Reset selected mappings
            setExcelValido(true);
        } catch (err) {
            console.error('Error reading Excel file:', err);
        } finally {
            event.target.value = '';
        }
    };

    const showToast = (message, type = "warning", durationMs = 3000, callback = null) => {
        setToastMessage(message);
        setToastType(type);
        setToastVisible(true);
        // Auto-hide
        window.clearTimeout(showToast._timer);
        showToast._timer = window.setTimeout(() => {
            setToastVisible(false);
            if (callback !== null) {
                callback();
            }
        }, durationMs);
    };

    const handleSaveClick = async () => {
        try {
            // setProcessingVisible(true);
            // setRequestSend(true);
            if (Object.keys(selectedMappings).length === 0) {
                showToast(t("alert_debe_seleccionar_columnas"));
                return;
            }
            // console.log('configuracionAsignacion');
            // console.log(configuracionAsignacion);
            let objEnviar = {};
            objEnviar.configuracion = selectedMappings;
            // console.log('objEnviar');
            // console.log(objEnviar);
            // return;
            setProcessingVisible(true);
            setRequestSend(true);
            if (configuracionAsignacion === null) {
                const response = await crearConfiguracionAsignacion(objEnviar);
                setProcessingVisible(false);
                if (response.error === false) {
                    showToast(t("alert_se_creo_correctamente"), "success", 3000, handleCancelClick);
                }
                if (response.error === true) {
                    showToast(t("alert_no_se_pudo_crear"));
                }
            }
            if (configuracionAsignacion !== null) {
                objEnviar.id = configuracionAsignacion.id;
                const response = await actualizarConfiguracionAsignacion(objEnviar);
                setProcessingVisible(false);
                if (response.error === false) {
                    showToast(t("alert_se_modifico_correctamente"), "success", 3000, handleCancelClick);
                }
                if (response.error === true) {
                    showToast(t("alert_no_se_pudo_modificar"));
                }
            }
        } catch (err) {
            console.log('handleSaveClick err');
            console.log(err);
        } finally {
            setRequestSend(false);
        }
    };

    const render = () => {
        try {
            if (cargandoPage === true) {
                return cargandoCard();
            }
            // if (tieneAccesoAlModulo === false) {
            //     return sinAccesoCard();
            // }
            return (
                <div className="max-w-7xl mx-auto px-4 lg:px-6 bg-gray-100">
                    <br />
                    <div className="bg-white py-6 shadow-md rounded-lg sm:px-2">
                        <div className="flex items-center justify-between mb-4">
                            <div className="flex items-center gap-2">
                                {/* <ArrowBack onClick={handleCancelClick} /> */}
                                <h2 className="text-xl font-bold text-gray-900">{t("titulo_configuracion_asignacion")}</h2>
                            </div>
                            {btnImportar === true && (
                                <div>
                                    <button className="group relative bg-green-500 hover:bg-green-600 text-white px-4 py-2 rounded-md transition-all duration-300 transform hover:scale-110 hover:shadow-xl hover:shadow-green-500/50 flex items-center gap-2 overflow-hidden active:scale-95"
                                        onClick={onClickImportar}
                                    >
                                        <span className="relative z-10 flex items-center gap-2">
                                            <Upload className="h-4 w-4 transition-all duration-300 group-hover:-translate-y-1 group-hover:rotate-12 group-hover:scale-110" />
                                            <span className="font-medium transition-all duration-300 group-hover:tracking-wide">{t("label_importar")}</span>
                                        </span>
                                        <span className="absolute inset-0 bg-gradient-to-r from-green-400 via-green-500 to-green-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></span>
                                        <span className="absolute inset-0 bg-white opacity-0 group-hover:opacity-10 transition-opacity duration-300"></span>
                                        <span className="absolute -inset-1 bg-green-400 opacity-0 group-hover:opacity-20 blur-md transition-opacity duration-300"></span>
                                    </button>
                                </div>
                            )}
                            <input
                                type="file"
                                className="hidden"
                                id="importar_asignacion"
                                accept=".xlsx,.xls"
                                onChange={handleFileChange}
                            />
                        </div>
                        <div className="space-y-3">
                            {LISTA_REQUERIMIENTOS_ASIGNACION.map(item => {
                                const isExpanded = expandedItems[item.value] || false;
                                const isObligatorio = item.obligatorio === true;
                                const selectedValue = excelValido ? (selectedMappings[item.value] || null) : null;

                                return (
                                    <div key={item.value} className="grid grid-cols-12 gap-4 items-start">
                                        {/* Left Column - Input */}
                                        <div className="col-span-4 md:col-span-4 lg:col-span-4 xl:col-span-4">
                                            <div className="space-y-2">
                                                <div className="relative">
                                                    <input
                                                        type="text"
                                                        value={item.index + "-" + item.label}
                                                        readOnly
                                                        className={`w-full px-3 py-2 pr-10 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-400 bg-gray-50 text-gray-700 transition-colors ${isObligatorio
                                                            ? 'border-red-500 focus:ring-red-400'
                                                            : 'border-gray-300'
                                                            }`}
                                                    />
                                                    <button
                                                        type="button"
                                                        onClick={() => toggleExpand(item.value)}
                                                        className="absolute right-2 top-1/2 -translate-y-1/2 p-1 text-gray-600 hover:text-gray-800 hover:bg-gray-100 rounded transition-all duration-500"
                                                        aria-label={isExpanded ? t("label_ocultar_descripcion") : t("label_mostrar_descripcion")}
                                                    >
                                                        {isExpanded ? (
                                                            <ChevronUp className="h-5 w-5 transition-transform duration-500" />
                                                        ) : (
                                                            <ChevronDown className="h-5 w-5 transition-transform duration-500" />
                                                        )}
                                                    </button>
                                                </div>
                                                <div
                                                    className={`overflow-hidden transition-all duration-500 ease-in-out ${isExpanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                                                        }`}
                                                >
                                                    {item.descripcion && (
                                                        <div className="px-3 py-2 bg-gray-50 rounded-lg text-sm text-gray-600 mt-2">
                                                            {item.descripcion}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Right Column - Select (only when excel is valid) */}
                                        {excelValido && (
                                            <div className="col-span-8 md:col-span-8 lg:col-span-8 xl:col-span-8">
                                                <div className="space-y-2">
                                                    <div className="relative">
                                                        <Select
                                                            options={availableOptions}
                                                            value={selectedValue}
                                                            onChange={(option) => handleSelectChange(item.value, option)}
                                                            placeholder="Seleccione columna..."
                                                            isClearable={true}
                                                            isSearchable={true}
                                                            classNamePrefix="react-select"
                                                        />
                                                    </div>
                                                    <div
                                                        className={`overflow-hidden transition-all duration-500 ease-in-out ${isExpanded ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                                                            }`}
                                                    >
                                                        {item.descripcion && (
                                                            <div className="px-3 py-2 bg-gray-50 rounded-lg text-sm text-gray-600 mt-2">
                                                                {item.descripcion}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                );
                            })}
                        </div>
                        <br />
                        <div className="grid grid-cols-12 gap-4">
                            <div className="col-span-12 md:col-span-12 lg:col-span-12 xl:col-span-12">
                                <div className="flex justify-between">
                                    {btnCancelar === true && (
                                        <button
                                            type="button"
                                            className={ESTILO_BOTON_GENERAL_CANCELAR}
                                            onClick={handleCancelClick}
                                        >
                                            {t("label_cancelar")}
                                        </button>
                                    )}
                                    {btnAceptar === true && requestSend === false && (
                                        <button
                                            type="button"
                                            className={ESTILO_BOTON_GENERAL_ACEPTAR}
                                            onClick={handleSaveClick}
                                        >
                                            {t("label_aceptar")}
                                        </button>
                                    )}
                                    {requestSend === true && (
                                        <button
                                            type="button"
                                            className={ESTILO_BOTON_GENERAL_ACEPTAR}
                                            disabled
                                        >
                                            <div className="flex items-center justify-center gap-2">
                                                <Spinner size="md" color="green" />
                                            </div>
                                        </button>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <ProcessingDialog visible={processingVisible} message={t("alert_procesando_solicitud")} />
                    <ToastComponent
                        visible={toastVisible}
                        message={toastMessage}
                        type={toastType}
                        onClose={() => setToastVisible(false)}
                    />
                </div>
            );
        } catch (err) {
            console.log('render err AsignacionConfiguracionPage');
            console.log(err);
            return (
                <div className="m-8" >
                    <label>{JSON.stringify(err)}</label>
                </div>
            );
        }
    };

    return render();
};
